import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import { CloseButton, Container } from "../kiosk/component/styled/common";
import { KioskMemuList } from "../kiosk/component/styled/kiosk";

import { MdClose } from "react-icons/md";
import { useDisableScroll } from "../../../hooks/useDisableScroll";
import { checkKioskCond } from "../dashboard/component/function/dashboard";
import { exitFullscreen } from "../kiosk/component/function/kiosk";

const Bbdabang = () => {
  useDisableScroll();

  const navigate = useNavigate();

  const company = useSelector((state) => state?.company?.data);

  useEffect(() => {
    if (!checkKioskCond(company)) {
      toast.error("접근 권한이 없습니다.", { toastId: "no-access" });
      navigate("/mypage");
      return;
    }
  }, []);

  const sungsimdang = [
    { key: "storage", tit: "빵다방 보관", imagePath: "bbdabang" },
    { key: "pickup", tit: "찾기", imagePath: "bbdabang_cake" },
    { key: "salesCheck", tit: "매출관리", imagePath: "bbdabang_cookie" },
    { key: "reservationStatus", tit: "이용내역조회", imagePath: "bbdabang_bread" },
  ];

  const exitKioskPage = () => {
    exitFullscreen();
    navigate("/mypage");
  };

  return (
    <Container className="bg">
      <CloseButton>
        <button onClick={exitKioskPage}>
          <MdClose />
        </button>
      </CloseButton>
      <KioskMemuList className="baseball">
        {sungsimdang.map((item) => (
          <li
            key={item.key}
            className={item.key}
            onClick={() => navigate(`/mypage/bbdabang/${item.key}`)}>
            <div className="content">
              <div className="image">
                <img src={`/img/bbdabang/${item.imagePath}.png`} alt="" />
              </div>
              <span>{item.tit}</span>
            </div>
          </li>
        ))}
      </KioskMemuList>
    </Container>
  );
};

export default Bbdabang;
